import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, IconButton  } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { fetchSingleItem, updateItemEntry } from '../../Store/PHPSlice/Item';
import { useParams } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';

const ItemEdit = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        itemId: parseInt(Id),
        itemNm: '',
        hsn: '',
        itemImg: '',
        size: '',
        userId: ''
    });
    const [number, setNumber] = useState('');
    const [numbers, setNumbers] = useState([]);
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const singleItem = useSelector((state) => state.ItemData.singleItem || { data: [] });
    useEffect(() => {
        dispatch(fetchSingleItem(Id))
    }, [dispatch, Id]);

    useEffect(() => {
        if (singleItem.data.length > 0) {
            const item = singleItem.data[0];
            setFormData({
                ...formData,
                itemNm: item.itemNm,
                hsn: item.hsn,
                itemImg: item.itemImg,
                size: item.size,
            });
            setNumbers(item.size.split(','));
        }
    }, [singleItem]);

    if (!singleItem) {
        return <h1>Loading...</h1>
    }
    const handleAddNumber = () => {
        if (number !== '') {
            setNumbers([...numbers, number]);
            setNumber('');
        }
    };

    const handleNumberChange = (index, value) => {
        const updatedNumbers = numbers.map((num, i) => (i === index ? value : num));
        setNumbers(updatedNumbers);
    };
    const handleDeleteNumber = (index) => {
        const updatedNumbers = numbers.filter((_, i) => i !== index);
        setNumbers(updatedNumbers);
    };
    

    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            itemImg: e.target.files[0]
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.itemNm) newErrors.itemNm = 'Item Name is required';
        if (!formData.hsn) newErrors.hsn = 'HSN Code is required';
        if (numbers.length === 0) newErrors.sizes = 'At least one size is required';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const updatedFormData = {
            ...formData,
            size: numbers.join(',')
        };


        dispatch(updateItemEntry(updatedFormData))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                toast.success("Item Added");
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };



    return (
        <>

            <div style={{ margin: '6% 1%' }}>
                <h2>Item Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>
                                {[
                                    { label: 'Item Name', name: 'itemNm' },
                                    { label: 'HSN Code', name: 'hsn' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='itemImg'>Image:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='itemImg'
                                                    name='itemImg'
                                                    type="file"
                                                    onChange={handleImageChange}
                                                    inputProps={{ style: styled.inputImg }}
                                                    sx={inputImages}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>

                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='number'>Sizes:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.sizes}>
                                                <TextField
                                                    type='text'
                                                    id='number'
                                                    name='number'
                                                    value={number}
                                                    onChange={(e) => setNumber(e.target.value)}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}
                                                />
                                                {errors.sizes && <FormHelperText style={errorStyles}>{errors.sizes}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleAddNumber}>Add Size</Button>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TableContainer style={isDesktop ? { marginLeft: '25.5%', width: 250 } : { marginLeft: '0%', width: 250 }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1 }} align='center'>SrNo</TableCell>
                                                    <TableCell sx={{ p: 1 }} align='center'>Size</TableCell>
                                                    <TableCell sx={{ p: 1 }} align='center'>Delete</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {numbers.map((num, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ p: 1 }} align='center'>{index + 1}</TableCell>
                                                        <TableCell sx={{ p: 1 }} align='center'>
                                                            <TextField
                                                                type="text"
                                                                value={num}
                                                                onChange={(e) => handleNumberChange(index, e.target.value)}
                                                                inputProps={{ style: styled.inputs }}
                                                                sx={inputNumbers}
                                                            />
                                                        </TableCell>
                                                         <TableCell sx={{ p: 1 }} align='center'>
                                                            <IconButton onClick={() => handleDeleteNumber(index)} color="secondary">
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ItemEdit;
